import { IChangeSubCategoryPositionContext } from './changeSubCategoryPositionContext';

export enum ChangeSubCategoryPositionActionTypes {
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_RESTAURANT = 'SET_RESTAURANT',
	SET_ID_CATEGORY = 'SET_ID_CATEGORY',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_POSITIONS_DATA = 'SET_POSITIONS_DATA',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL = 'SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL',
	TOGGLE_APPLY_TO_ONE = 'TOGGLE_APPLY_TO_ONE',
	SET_ADDITIONAL_RESTAURANTS = 'SET_ADDITIONAL_RESTAURANTS',
	CHANGE_SELECT_SEARCH_STRING = 'CHANGE_SELECT_SEARCH_STRING',
}

interface ISetIDCustomer {
	type: ChangeSubCategoryPositionActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: IChangeSubCategoryPositionContext['IDSelectedCustomer'];
	};
}

interface ISetRestaurant {
	type: ChangeSubCategoryPositionActionTypes.SET_RESTAURANT;
	payload: {
		selectedRestaurant: IChangeSubCategoryPositionContext['selectedRestaurant'];
	};
}

interface ISetIDCategory {
	type: ChangeSubCategoryPositionActionTypes.SET_ID_CATEGORY;
	payload: {
		IDSelectedCategory: IChangeSubCategoryPositionContext['IDSelectedCategory'];
	};
}

interface IResetSelectedControls {
	type: ChangeSubCategoryPositionActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetPositionsData {
	type: ChangeSubCategoryPositionActionTypes.SET_POSITIONS_DATA;
	payload: {
		positionsData: IChangeSubCategoryPositionContext['positionsData'];
	};
}

interface IChangeTypeOfModalWindow {
	type: ChangeSubCategoryPositionActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IChangeSubCategoryPositionContext['typeOfModalWindow'];
	};
}

interface ISetVisibleAdditionalRestaurantsModal {
	type: ChangeSubCategoryPositionActionTypes.SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL;
	payload: {
		isVisibleAdditionalRestaurantsModal: IChangeSubCategoryPositionContext['isVisibleAdditionalRestaurantsModal'];
		isApplyToOne: IChangeSubCategoryPositionContext['isApplyToOne'];
		selectedAdditionalRestaurants: IChangeSubCategoryPositionContext['selectedAdditionalRestaurants'];
		selectSearchString: IChangeSubCategoryPositionContext['selectSearchString'];
	};
}

interface IToggleApplyToOne {
	type: ChangeSubCategoryPositionActionTypes.TOGGLE_APPLY_TO_ONE;
}

interface ISetAdditionalRestaurants {
	type: ChangeSubCategoryPositionActionTypes.SET_ADDITIONAL_RESTAURANTS;
	payload: {
		selectedAdditionalRestaurants: IChangeSubCategoryPositionContext['selectedAdditionalRestaurants'];
	};
}

interface IChangeSelectSearchString {
	type: ChangeSubCategoryPositionActionTypes.CHANGE_SELECT_SEARCH_STRING;
	payload: {
		selectSearchString: IChangeSubCategoryPositionContext['selectSearchString'];
	};
}

export type TChangeSubCategoryPositionActions =
	| ISetIDCustomer
	| ISetRestaurant
	| ISetIDCategory
	| IResetSelectedControls
	| ISetPositionsData
	| IChangeTypeOfModalWindow
	| ISetVisibleAdditionalRestaurantsModal
	| IToggleApplyToOne
	| ISetAdditionalRestaurants
	| IChangeSelectSearchString;
